import React from 'react';

const SvgSv = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SV_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="SV_svg__c">
        <stop stopColor="#3C7839" offset="0%" />
        <stop stopColor="#31642E" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SV_svg__b" fill="#fff">
        <use xlinkHref="#SV_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#1B57C4"
        mask="url(#SV_svg__b)"
        d="M0 0h28v6.667H0zM0 13.333h28V20H0z"
      />
      <path
        d="M12.4 7.867l.933 2.8h1.334l.933-2.8a2.667 2.667 0 1 1-3.2 0z"
        fill="url(#SV_svg__c)"
        mask="url(#SV_svg__b)"
      />
      <path
        fill="#F9C92E"
        mask="url(#SV_svg__b)"
        d="M14 7.333l.667 3.334h-1.334z"
      />
    </g>
  </svg>
);

export default SvgSv;
